import { BRIEF_TYPE, getBrandBriefTypeLabel, mapContentForBriefInput } from 'src/data/brief';
import { getGenderLabel } from 'src/data/demographics';
import { getSuggestedAnnotationsOriginLabel } from 'src/data/performance';

export const mapToneOfVoiceForInfinity = (toneOfVoice) => {
  if (!toneOfVoice) {
    return null;
  }

  return {
    id: toneOfVoice.id,
    name: toneOfVoice.description || toneOfVoice.name,
  };
};

export const mapPersonaForInfinity = (persona) => {
  if (!persona) {
    return null;
  }

  return {
    id: persona.id,
    name: persona.name,
    maxAge: persona.maxAge,
    minAge: persona.minAge,
    gender: persona.gender,
    genderLabel: getGenderLabel(persona.gender),
    painPoints: persona.painPoints,
  };
};

export const mapBrandTermsForInfinity = (brandTerms) => {
  if (!brandTerms || brandTerms.length === 0) {
    return [];
  }

  return brandTerms.map((item) => item?.term || '');
};

export const mapBriefForInfinity = (brief) => {
  if (!brief) {
    return null;
  }

  const content = mapContentForBriefInput(BRIEF_TYPE.DEFAULT, brief);
  return {
    name: content.title,
    typeName: 'Product Description',
    body: content.body,
  };
};

export const mapBrandBriefForInfinity = (brief) => {
  if (!brief) {
    return null;
  }

  return {
    id: brief.id,
    name: brief.name,
    typeName: getBrandBriefTypeLabel(brief.briefType),
    body: brief.body,
  };
};

export const mapBrandBriefsForInfinity = (briefs) => {
  if (!briefs || briefs.length === 0) {
    return [];
  }

  return briefs.map(mapBrandBriefForInfinity);
};

export const mapResourcesForInfinity = (resources) => {
  if (!resources || resources.length === 0) {
    return [];
  }

  return resources.map((resource) => ({
    id: resource.id,
    url: resource.url,
    typeName: getSuggestedAnnotationsOriginLabel(resource.websiteType),
  }));
};
